import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { updateLeadDataOfContact } from '../../Utility/UpdateLeadData/UpdateLeadData';
import { updateTaskDataOfContact } from '../../Utility/UpdateTaskData/UpdateTaskData';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import Backdrop from '@mui/material/Backdrop';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import { loginTimeOutAndRedirectHandler } from '../../Utility/LoginTimeOutAndRedirectHandler/LoginTimeOutAndRedirectHandler';
import { setAllDataOfContact } from '../../Redux/Index';
import { useDispatch } from 'react-redux';
import RelatedTaskDisplay from '../RelatedTaskDisplay/RelatedTaskDisplay';
import RelatedTaskEdit from '../RelatedTaskEdit/RelatedTaskEdit';

const mapStateToPropsForAllData = state => {
  return {
    allDataOfContact: state.allDataOfUser.allDataOfContact
  }
}

function LeadDetail({ allDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const originalId = id.substring(9, id.length - 4);

  const [isDataSubmitting, setIsDataSubmitting] = useState(false);
  const [isSaveButtonClicked2, setIsSaveButtonClicked2] = useState(false);
  const [isPopupOpened2, setIsPopupOpened2] = useState(false);
  const [taskAndStageDataSubmitted, setTaskAndStageDataSubmitted] = useState(false);
  const [updatingTaskData, setUpdatingTaskData] = useState("");
  const [nameError, setNameError] = useState(false);
  const [companyError, setCompanyError] = useState(false);
  const [statusError, setStatusError] = useState(false);
  const [leadOwnerError, setLeadOwnerError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [leadData, setLeadData] = useState({
    Id: originalId
  });

  useEffect(() => {

    if((allDataOfContact) && (allDataOfContact.success)) {
      setIsLoading(false);
    }

    if(Object.keys(leadData).length === 1) {
      if(allDataOfContact.data && allDataOfContact.data.Leads) {
        allDataOfContact.data.Leads.records.forEach((rowData) => {
          if(rowData.Id == originalId) {
            setLeadData(rowData);
            return;
          }
        });
      }
  
    } 
    
  }, [allDataOfContact, isLoading, leadData]);

  // Input value handler start

  const handleInputChange = (e) => {
    const { name, value } = e.target;

      setLeadData({
        ...leadData,
        [name]: value,
      });
    
  };

  // Input value handler end

  // Input fields error handler start

  const nameFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Name" && value=="") {
      setNameError(true);
    } else {
      setNameError(false);
    }
  }

  const companyFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Company" && value=="") {
      setCompanyError(true);
    } else {
      setCompanyError(false);
    }
  }

  const statusFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Status" && value=="--None--") {
      setStatusError(true);
    } else {
      setStatusError(false);
    }
  }

  const leadOwnerFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="OwnerId" && value=="--None--") {
      setLeadOwnerError(true);
    } else {
      setLeadOwnerError(false);
    }
  }

  // Input fields error handler end

  // Input value handler start

  const handleInputChange5 = (e) => {
    const { name, value } = e.target;

    setUpdatingTaskData({
      ...updatingTaskData,
      [name]: value
    });
    
  };

  // Input value handler end

  // Lead and task submit func start

  function submitLeadData() {
    loginTimeOutAndRedirectHandler(updateLeadDataOfContact, leadData, dispatch, setAllDataOfContact, navigate, "/", "Lead detail updated!", setIsDataSubmitting, "/Leads");
  }

  function submitTaskData() {
    setTaskAndStageDataSubmitted(true);
    loginTimeOutAndRedirectHandler(updateTaskDataOfContact, updatingTaskData, dispatch, setAllDataOfContact, navigate, "/", "Task detail updated!", setIsDataSubmitting, "");
  }

  // Lead and task submit func end

  //let taskDataFound = false;

  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      <Grid item xs={8} style={{ borderRight: (Object.keys(leadData).length === 1 ? "" : "3px solid black") }}>
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'center', marginLeft: 2, marginBottom: 2, fontWeight: 'bold' }}
            >
              Lead Detail
            </Typography>
        <CssBaseline />
        { Object.keys(leadData).length === 1 ?  <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}><CircularProgress /></Box> : <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="name" style={{ textAlign: "left" }}><span style={{ color: 'red' }}>*</span> Name</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              required
              id="name"
              name="Name"
              placeholder="Enter Name"
              value={leadData.Name == null ? "" : leadData.Name}
              onChange={(e) => { nameFieldErrorHandler(e);handleInputChange(e); }}
              error={nameError}
              helperText={nameError ? 'Name is required!' : ''}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="status" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Status</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                required
                id="status"
                value={(leadData.Status == "--None--" || leadData.Status == null) ? "--None--" : leadData.Status}
                name="Status"
                placeholder="Select Status"
                onChange={(e) => { statusFieldErrorHandler(e);handleInputChange(e); }}
                style={{ textAlign: "left" }}
                error={statusError}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Open - Not Contacted"}>Open - Not Contacted</MenuItem>
                <MenuItem value={"Working - Contacted"}>Working - Contacted</MenuItem>
                <MenuItem value={"Closed - Converted"}>Closed - Converted</MenuItem>
                <MenuItem value={"Closed - Not Converted"}>Closed - Not Converted</MenuItem>
              </Select>
              <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ statusError ? ' Status is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="leadSource" style={{ textAlign: "left", marginBottom: "1rem" }}>Lead Source</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="leadSource"
                value={(leadData.LeadSource == "--None--" || leadData.LeadSource == null) ? "--None--" : leadData.LeadSource}
                name="LeadSource"
                placeholder="Select Lead Source"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Web"}>Web</MenuItem>
                <MenuItem value={"Phone Inquiry"}>Phone Inquiry</MenuItem>
                <MenuItem value={"Partner Referral"}>Partner Referral</MenuItem>
                <MenuItem value={"Purchased List"}>Purchased List</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="rating" style={{ textAlign: "left", marginBottom: "1rem" }}>Rating</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="rating"
                value={(leadData.Rating == "--None--" || leadData.Rating == null) ? "--None--" : leadData.Rating}
                name="Rating"
                placeholder="Select Rating"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Hot"}>Hot</MenuItem>
                <MenuItem value={"Warm"}>Warm</MenuItem>
                <MenuItem value={"Cold"}>Cold</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="phoneNumber" style={{ textAlign: "left" }}>Phone</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="number"
              id="phoneNumber"
              value={leadData.Phone == null ? "" : leadData.Phone}
              name="Phone"
              placeholder="Enter Phone Number"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="email" style={{ textAlign: "left" }}>Email</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="email"
              type="email"
              value={leadData.Email == null ? "" : leadData.Email}
              name="Email"
              placeholder="Enter Email Address"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="company" style={{ textAlign: "left" }}><span style={{ color: 'red' }}>*</span> Company</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="company"
              name="Company"
              required
              error={companyError}
              value={leadData.Company == null ? "" : leadData.Company}
              helperText={companyError ? 'Company is required!' : ''} 
              placeholder="Enter Company Name"
              onChange={(e) => { companyFieldErrorHandler(e);handleInputChange(e); }}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="industry" style={{ textAlign: "left", marginBottom: "1rem" }}>Industry</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="industry"
                value={(leadData.Industry == "--None--" || leadData.Industry == null) ? "--None--" : leadData.Industry}
                name="Industry"
                placeholder="Select Industry"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Agriculture"}>Agriculture</MenuItem>
                <MenuItem value={"Apparel"}>Apparel</MenuItem>
                <MenuItem value={"Banking"}>Banking</MenuItem>
                <MenuItem value={"Biotechnology"}>Biotechnology</MenuItem>
                <MenuItem value={"Chemicals"}>Chemicals</MenuItem>
                <MenuItem value={"Communications"}>Communications</MenuItem>
                <MenuItem value={"Construction"}>Construction</MenuItem>
                <MenuItem value={"Consulting"}>Consulting</MenuItem>
                <MenuItem value={"Education"}>Education</MenuItem>
                <MenuItem value={"Electronics"}>Electronics</MenuItem>
                <MenuItem value={"Energy"}>Energy</MenuItem>
                <MenuItem value={"Engineering"}>Engineering</MenuItem>
                <MenuItem value={"Entertainment"}>Entertainment</MenuItem>
                <MenuItem value={"Environmental"}>Environmental</MenuItem>
                <MenuItem value={"Finance"}>Finance</MenuItem>
                <MenuItem value={"Food & Beverage"}>Food & Beverage</MenuItem>
                <MenuItem value={"Government"}>Government</MenuItem>
                <MenuItem value={"Healthcare"}>Healthcare</MenuItem>
                <MenuItem value={"Hospitality"}>Hospitality</MenuItem>
                <MenuItem value={"Insurance"}>Insurance</MenuItem>
                <MenuItem value={"Machinery"}>Machinery</MenuItem>
                <MenuItem value={"Manufacturing"}>Manufacturing</MenuItem>
                <MenuItem value={"Media"}>Media</MenuItem>
                <MenuItem value={"Not For Profit"}>Not For Profit</MenuItem>
                <MenuItem value={"Recreation"}>Recreation</MenuItem>
                <MenuItem value={"Retail"}>Retail</MenuItem>
                <MenuItem value={"Shipping"}>Shipping</MenuItem>
                <MenuItem value={"Technology"}>Technology</MenuItem>
                <MenuItem value={"Telecommunications"}>Telecommunications</MenuItem>
                <MenuItem value={"Transportation"}>Transportation</MenuItem>
                <MenuItem value={"Utilities"}>Utilities</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
                <MenuItem value={"Communication"}>Communication</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="description" style={{ textAlign: "left" }}>Description</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="description"
              name="Description"
              value={leadData.Description == null ? "" : leadData.Description}
              placeholder="Enter Description Here"
              onChange={handleInputChange}
              multiline
              rows={2}
              maxRows={4}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="communicationWithClient" style={{ textAlign: "left" }}>Communication With Client</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="communicationWithClient"
              name="CommunicationWithClient__c"
              value={leadData.CommunicationWithClient__c == null ? "" : leadData.CommunicationWithClient__c}
              placeholder="Enter Conversation Here"
              onChange={handleInputChange}
              multiline
              rows={2}
              maxRows={4}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="leadOwner" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Lead Owner</InputLabel>
            <Select
                margin="normal"
                fullWidth
                type="select"
                id="leadOwner"
                value={(leadData.OwnerId == "--None--" || leadData.OwnerId == null) ? "--None--" : leadData.OwnerId}
                name="OwnerId"
                placeholder="Select Owner Name"
                onChange={(e) => {leadOwnerFieldErrorHandler(e);handleInputChange(e);}}
                style={{ textAlign: "left" }}
                required
                error={leadOwnerError}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                { allDataOfContact?.data?.Users?.records?.map((userData, index) => {
                  return <MenuItem value={userData.Id}>{userData.Name}</MenuItem>
                }) }
              </Select>
              <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ leadOwnerError ? ' Lead owner is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="mobile" style={{ textAlign: "left" }}>Mobile</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="mobile"
              name="MobilePhone"
              value={leadData.MobilePhone == null ? "" : leadData.MobilePhone}
              placeholder="Enter Mobile Number"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={2} md={6} lg={8}>
            
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => { setIsDataSubmitting(true);submitLeadData() }}
              disabled={ (leadData.Name == "" || leadData.OwnerId == "--None--" || leadData.Status == "--None--" || leadData.Company == "") ? true : false }
            >
              { isDataSubmitting ? <CircularProgress size={24} style={{ color: "white" }} /> : "Update" }
            </Button>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Link to="/Leads" style={{ textDecoration: 'none', color: 'transparent' }}>
            <Button
              type="submit"
              fullWidth
              variant="outlined"
              sx={{ mt: 3, mb: 2 }}
            >
              Cancel
            </Button>
            </Link>
            </Grid>
          </Grid>
        </Box> }
  </Container>
  </Grid>

  {/* Related list of task display and edit form start */}

  <Grid item xs={4}>

  <RelatedTaskDisplay objData={leadData} idtype="WhoId" allDataOfContact={allDataOfContact} setUpdatingTaskData={setUpdatingTaskData} setIsPopupOpened2={setIsPopupOpened2} />
  <RelatedTaskEdit isPopupOpened2={isPopupOpened2} updatingTaskData={updatingTaskData} isSaveButtonClicked2={isSaveButtonClicked2} handleInputChange5={handleInputChange5} setIsPopupOpened2={setIsPopupOpened2} setIsSaveButtonClicked2={setIsSaveButtonClicked2} submitTaskData={submitTaskData} />

  </Grid>
  {/* Related list of task display and edit form end */}
  <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={taskAndStageDataSubmitted}
              onClick={() => {
                return;
              }}
            >
            <Box
            sx={{
              display: 'flex',
              position: 'absolute',
              top: "40%",
              zIndex: 2,
              flexWrap: 'wrap',
              '& > :not(style)': {
                m: 1,
                width: '80px',
                height: '80px',
              },
            }}
             >
            <CircularProgress style={{ color: "white" }} />
            </Box>
  </Backdrop> 
  </Grid>
  )
}

export default connect(mapStateToPropsForAllData)(LeadDetail);